// Calibrated to the road intersection in the 1440 x 900 background plate.
export const VANISHING_POINT = { x: 738, y: 461 };

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export function projectPerspective({ depth, lane, baseSize }) {
  const z = Math.max(depth, 0.012);
  const perspective = 1 / z;
  const roadSpread = 32 * perspective;

  return {
    x: VANISHING_POINT.x + lane * roadSpread,
    y: VANISHING_POINT.y + 13 * perspective,
    scale: baseSize * 0.12 * perspective,
    opacity: clamp((1.12 - z) * 2.4, 0, 1),
    perspective,
  };
}

export function createMotionWorld() {
  return {
    time: 0,
    objects: [
      { id: "scooter-ahead", type: "scooter", lane: -0.52, depth: 0.82, relativeSpeed: 0.026, baseSize: 96, startAt: 0 },
      { id: "oncoming-auto", type: "auto", lane: 0.9, depth: 1.08, relativeSpeed: 0.105, baseSize: 112, startAt: 3.2 },
      { id: "shop-pedestrian", type: "pedestrian", lane: -1.12, depth: 0.76, relativeSpeed: 0.055, baseSize: 74, startAt: 1.1, endDepth: -0.1 },
      { id: "waiting-pedestrian", type: "pedestrian", lane: 1.03, depth: 0.92, relativeSpeed: 0.038, baseSize: 42, startAt: 7.4, endDepth: 0.08, stationary: true },
      { id: "left-tree", type: "tree", lane: -1.08, depth: 0.64, relativeSpeed: 0.072, baseSize: 115, startAt: 0, endDepth: -0.12 },
      { id: "right-pole", type: "pole", lane: 1.02, depth: 0.72, relativeSpeed: 0.09, baseSize: 72, startAt: 0, endDepth: -0.12 },
      { id: "left-sign", type: "sign", lane: -1.0, depth: 1.0, relativeSpeed: 0.078, baseSize: 66, startAt: 8.2, endDepth: -0.12 },
    ],
  };
}

export function updateMotionWorld(world, deltaTime, running) {
  if (!running) return;
  world.time += deltaTime;
  world.objects.forEach(object => {
    if (object.finished || world.time < object.startAt) return;
    object.depth -= object.relativeSpeed * deltaTime;
    const screen = projectPerspective(object);
    const outside = screen.x + screen.scale < 0 || screen.x - screen.scale > 1440 || screen.y - screen.scale > 900;
    if (object.depth <= 0 || outside) object.finished = true;
  });
}

export function visibleObjects(world) {
  return world.objects
    .filter(object => !object.finished && world.time >= object.startAt)
    .map(object => ({ ...object, screen: projectPerspective(object) }))
    .sort((a, b) => b.depth - a.depth);
}
